
import {
    mapState,
    mapActions,
} from 'vuex'
import viewName from '../constant.js'
import { Swipe, SwipeItem, Button } from 'vant'
import InfiniteLoading from 'vue-infinite-loading'
import guideFloating from '@/components/guideFloating/guideFloating.vue'
import errLocationDialog from '@/components/errLocationDialog/errLocationDialog.vue'
import {
    Banner,
    Title,
    GoodsSwiper,
    GoodsList,
} from '@/components/customPromotion'
import { wxShare } from '@/utils/wxsdk'
import {
    getPromotionInfo,
    getPromotionGoodsInfo,
    getPromotionFloorInfo,
    getScanSstore
} from '@/models/custom'
import { queryKey } from '@/utils/util'
import { isIOS, isAndroid } from '@/utils/ua'
import _ from 'lodash'

export default {
    name: viewName.customSingularDetail,
    inject: ['showLoading', 'hideLoading'],
    components: {
        [Swipe.name]: Swipe,
        [SwipeItem.name]: SwipeItem,
        [Button.name]: Button,
        InfiniteLoading,
        Banner,
        Title,
        GoodsSwiper,
        GoodsList,
        guideFloating,
        errLocationDialog
    },
    data () {
        return {
            detailParams: {
                sstore_id: '', // 门店id
                topic_id: '', // 推广id
                topic_type: 1, // 推广类型, 0: 常规, 1：自定义
                latitude: '', // 经度
                longitude: '', // 纬度
            },
            scan: '', // 后端字段粘贴物料二维码链接携带字段scan=1
            // 门店信息
            sstore: {
                sstore_phone: '',
                sstore_name: '', // 门店名称
                sstore_address: '', // 门店地址
                distance: '', // 距离
            },
            page_size: 12,
            page_no: 1,
            pageSize: 2,
            pageNo: 1,
            pageStatus: true,
            page_bg_color: '', // 页面背景颜色
            banner: {
                url: '', // 头图
            },
            floor: {
                floor_title: '', // 主推楼层名称
                floor_title_bg_img: '', // 主推楼层名称底图
                floor_goods_title: '', // 商品楼层名称
                floor_goods__bg_img: '', // 商品楼层名称底图
                floor_goods: [
                    // {
                    //     spu_id: '', // 商品规格id
                    //     goods_id: '', // 商品id
                    //     goods_img: '', // 商品图片
                    //     goods_name: '', // 商品名称
                    //     goods_price: '', // 商品原价
                    //     goods_present_price: '', // 商品现价
                    //     goods_sell_out: 1 || 0, // 是否已售罄, 0: 未售罄, 1： 已售罄
                    // },
                ]
            },
            share: {
                title: '', // 分享标题
                desc: '', // 分享描述
                imgUrl: '', // 分享图片
            },
            goodsList: [
                // {
                //     spu_id: '', // 商品规格id
                //     goods_id: '', // 商品id
                //     goods_img: '', // 商品图片
                //     goods_name: '', // 商品名称
                //     goods_price: '', // 商品原价
                //     goods_present_price: '', // 商品现价
                //     goods_sell_out: 1 || 0, // 是否已售罄, 0: 未售罄, 1： 已售罄
                // }
            ],
            floatBtnList: [{ key: 'feedback', top: '68' }, { key: 'top', top: '76.5' }],
            floor_infos: [], // 楼层
            specially_activity_data: { // 特惠活动
                floor_bg_img: '',
                floor_name: '',
                list: []
            },
            isSelectSidBack: false, // 是否选择门店-返回
            scanCustomSingularDetail: false, // 是否缓存session
            successPosition: true, // 是否定位成功
        }
    },
    watch: {
        '$route' (to, from) {
            // 对路由变化作出响应...
            if ((to.path === from.path) || (from.path === '/customSingularStoreList' && this.$route.query.isSelectSidBack)) {
                document.body.scrollIntoView()
                this.isSelectSidBack = true
                this.detailParams.sstore_id = this.$route.query.sstore_id
                this.pageNo = 1
                this.floor_infos = []
                this.getPromotionData()
                this.$refs.infiniteLoading && this.$refs.infiniteLoading.stateChanger.reset()
                // this.infinite()
            }
        },
    },
    computed: {
        ...mapState({
            isWeixin: ({
                appInfo
            }) => appInfo.isWeixin,
            icarAppInfo: ({ appInfo }) => appInfo.icarAppInfo
        }),
        isApp () {
            return this.icarAppInfo.app_name === 'iCar_app'
        },
    },
    beforeRouteEnter (to, from, next) {
        // to.meta.keepAlive = true
        next(vm => {
            // Object.assign(vm.detailParams, to.query)
            vm.page_bg_color && vm.doBgColor()
        })
    },
    created () {
        this.setAppClass({
            isAppend: true,
            className: 'bgGreyColor'
        })
        if (!queryKey(this.$route.query, ['longitude', 'latitude'])) {
            this.getMyLocation()
        }
        const { scan } = this.$route.query
        this.scan = scan
        if (this.scan) {
            sessionStorage.setItem('scanCustomSingularDetail', this.scan)
        } else {
            if (sessionStorage.getItem('scanCustomSingularDetail')) {
                this.scanCustomSingularDetail = true
            }
        }
    },
    activated () {
    },
    deactivated () {
        this.doBgColor('del')
    },
    mounted () {
        document.body.scrollIntoView()
        Object.assign(this.detailParams, this.$route.query)
        delete this.detailParams.scan
        if (queryKey(this.$route.query, ['longitude', 'latitude'])) {
            this.getPromotionData()
        }
    },
    methods: {
        ...mapActions([
            'setAppClass',
            'getLocation'
        ]),
        wxShareConfig () {
            wxShare(Object.assign(this.share, {link: location.href}))
        },
        doBgColor (type) {
            const app = document.querySelector('#app')
            const mainBox = app.querySelector('.mainBox')
            if (type === 'del') {
                app.removeAttribute('style')
                mainBox.setAttribute('style', `padding-top: ${(this.isWeixin || this.isApp) ? '0px' : '1.173333rem'}`)
            } else {
                app.setAttribute('style', `background-color: ${this.page_bg_color || '#b72021'}`)
                if ((!this.isWeixin && !this.isApp) && (isAndroid() || isIOS())) {
                    mainBox.setAttribute('style', `margin-top: 1.173333rem;padding-top:`)
                }
            }
        },
        getPromotionData () {
            this.showLoading()
            getPromotionInfo(this.detailParams)
                .then(res => {
                    this.hideLoading()
                    Object.assign(this, res)
                    this.$emit('setHeader', {
                        title: res.share.title,
                        showHeader: true,
                        showLeft: true,
                    })
                    this.isWeixin && this.wxShareConfig()
                    // 防止接口返回内容太慢，而用户点击跳转页面，导致改变了其他页面背景颜色
                    if (this.$route.path === '/customSingularDetail') {
                        this.page_bg_color && this.doBgColor()
                    }
                })
                .catch(err => {
                    this.hideLoading()
                    if (err.errcode === 9110) {
                        this.pageStatus = false
                        this.$router.push({
                            path: '/pageNotFound',
                            query: {
                                sstore_id: this.detailParams.sstore_id || '',
                            }
                        })
                    }
                })
        },
        infinite: _.throttle(function () {
            if (Number(this.scan) === 1 && !this.isSelectSidBack) {
                return
            }
            this.getFloorData()
        }, 500),
        getGoodsListInfo () {
            getPromotionGoodsInfo({
                topic_type: this.detailParams.topic_type, // 类型，0：常规，1：自定义
                topic_id: this.detailParams.topic_id || '',
                sstore_id: this.detailParams.sstore_id || '',
                page: this.page_no,
                pagesize: this.page_size,
                floor_type: 2, // 商品类型 1主推商品 2楼层商品
            })
                .then(data => {
                    this.goodsList.push(...data)
                    if (data.length < this.page_size) {
                        this.$refs.infiniteLoading && this.$refs.infiniteLoading.stateChanger.complete()
                    } else {
                        this.$refs.infiniteLoading && this.$refs.infiniteLoading.stateChanger.loaded()
                    }
                })
                .catch(err => {
                    console.log(err)
                })
        },
        async getFloorData () {
            try {
                const { floor_infos } = await getPromotionFloorInfo({
                    topic_type: 1,
                    topic_id: this.detailParams.topic_id || '',
                    sstore_id: this.detailParams.sstore_id || '',
                    is_specially_activity: 0, // 0或者不传为楼层商品，1特惠活动
                    page: this.pageNo, // 获取特惠活动不传
                    pagesize: this.pageSize // 获取特惠活动不传
                })
                _.map(floor_infos, item => {
                    if (item.shop_info.length > 6) {
                        item.shop_info = item.shop_info.slice(0, 6)
                        item.showMore = true
                    } else {
                        item.showMore = false
                    }
                })
                this.floor_infos.push(...floor_infos)
                if (floor_infos.length < this.pageSize) {
                    this.$refs.infiniteLoading && this.$refs.infiniteLoading.stateChanger.complete()
                    // 获取特惠活动
                    this.getSpeciallyData()
                } else {
                    this.pageNo += 1
                    this.$refs.infiniteLoading && this.$refs.infiniteLoading.stateChanger.loaded()
                }
            } catch (err) {
                this.$refs.infiniteLoading && this.$refs.infiniteLoading.stateChanger.complete()
                console.log(err)
            }
        },
        async getSpeciallyData () {
            try {
                const { specially_activity_data } = await getPromotionFloorInfo({
                    topic_type: 1,
                    topic_id: this.detailParams.topic_id || '',
                    sstore_id: this.detailParams.sstore_id || '',
                    is_specially_activity: 1, // 0或者不传为楼层商品，1特惠活动
                })
                this.specially_activity_data = specially_activity_data
            } catch (err) {
                console.log(err)
            }
        },
        goMarketingActivities (package_id) {
            this.$router.push({
                path: '/marketingActivities',
                query: {
                    package_id,
                    sstore_id: this.detailParams.sstore_id,
                }
            })
        },
        goMore (floorId, title) {
            this.$router.push({
                path: '/customSingularGoodsList',
                query: {
                    topic_id: this.detailParams.topic_id,
                    sstore_id: this.detailParams.sstore_id,
                    page_code: 'customSingularDetail',
                    title,
                    floor_id: floorId,
                    latitude: this.detailParams.latitude,
                    longitude: this.detailParams.longitude,
                }
            })
        },
        goodsCallback (params) {
            const { value, cb } = params
            Object.assign(value, {
                topic_id: this.detailParams.topic_id,
                sstore_id: this.detailParams.sstore_id,
                topic_type: this.detailParams.topic_type,
                page_code: 'customSingularDetail',
            })
            cb(value)
        },
        getMyLocation () {
            const options = { timeout: 3000, from: 'noTips' }
            this.getLocation(options)
                .then(this.showPosition)
                .catch(this.showErr)
                .finally(() => {
                    // this.getPromotionData()
                })
        },
        /* 获取位置信息成功 */
        showPosition (position) {
            this.detailParams.longitude = position.lng
            this.detailParams.latitude = position.lat
            this.successPosition = true
            if (Number(this.scan) === 1) {
                this.getScanSid()
            } else {
                this.getPromotionData()
            }
        },
        /* 获取位置信息失败，定位失败再请求定位，测试使用 */
        showErr () {
            // 定位同和地铁站
            this.successPosition = false
            if (Number(this.scan) === 1) { // 物料码
                this.$refs.errLocation.show = true
            } else {
                this.detailParams.longitude = 113.332926
                this.detailParams.latitude = 23.202723
                this.getPromotionData()
            }
        },
        getScanSid () {
            let par = {
                longitude: this.detailParams.longitude,
                latitude: this.detailParams.latitude
            }
            getScanSstore(par)
                .then(res => {
                    this.$router.replace({
                        path: '/customSingularDetail',
                        query: {
                            sstore_id: res.sstore_id,
                            topic_id: this.detailParams.topic_id,
                        }
                    })
                })
        },
        changeStoreList () { // 切换门店
            this.$router.push({
                path: '/customSingularStoreList',
                query: {
                    topic_id: this.detailParams.topic_id,
                    topic_type: 1,
                    longitude: this.detailParams.longitude,
                    latitude: this.detailParams.latitude
                }
            })
            this.$refs.errLocation.show = false
        },
        // 点击导航去门店
        goMap () {
            window.location.href = `https://api.map.baidu.com/marker?location=${this.sstore.latitude},${this.sstore.longitude}&title=${this.sstore.sstore_name}&content=${this.sstore.sstore_address}&output=html&src=webapp.baidu.openAPIdemo`
        },
        // 拨打电话
        dial () {
            window.location.href = `tel://${this.sstore.sstore_phone}`
        },
    },
    destroyed () {

    },
}
